import { useDispatch } from "react-redux";

import {
  closeExpertMatchDrawer,
  openExpertMatchDrawer,
  setModalViewType
} from "../../slices/uiSlice";

export const useUIBehavior = () => {
  const dispatch = useDispatch();

  return {
    closeExpertMatchDrawer: () => dispatch(closeExpertMatchDrawer()),
    openExpertMatchDrawer: () => dispatch(openExpertMatchDrawer()),
    setModalViewType: value => dispatch(setModalViewType(value))
  };
};
